import React from 'react';
import styled from 'styled-components';
import RecordDate from './RecordDate';
import RecordData from './RecordData';
import Loading from '../common/Loading';

const Container = styled.div`
  padding: 48px 20px 20px 20px;
  border-radius: 12px;
  background-color: #fff;
  margin-bottom: 20px;
  height: 800px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const EmptyBlock = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #666;
  font-size: 15px;
`;

const ContentsBlock = styled.div`
  display: flex;
  gap: 24px;
  width: 100%;
  flex: 1;
  min-height: 0;
`;

const DateSection = styled.div`
  flex-shrink: 0;
  width: 200px;
  max-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background: linear-gradient(white 30%, rgba(255,255,255,0)),
              linear-gradient(rgba(255,255,255,0), white 70%) 0 100%,
              radial-gradient(farthest-side at 50% 0, rgba(0,0,0,.15), rgba(0,0,0,0)),
              radial-gradient(farthest-side at 50% 100%, rgba(0,0,0,.15), rgba(0,0,0,0)) 0 100%;
  background-repeat: no-repeat;
  background-color: white;
  background-size: 100% 40px, 100% 40px, 100% 14px, 100% 14px;
  background-attachment: local, local, scroll, scroll;
  scrollbar-width: thin;
  scrollbar-color: #1976d2 #f5f5f5;

  ::-webkit-scrollbar {
    width: 8px;
  }
  
  ::-webkit-scrollbar-track {
    background: #f5f5f5;
    border-radius: 4px;
  }
  
  ::-webkit-scrollbar-thumb {
    background-color: #1976d2;
    border-radius: 4px;
  }
  
  ::-webkit-scrollbar-thumb:hover {
    background-color: #1565c0;
  }
`;

const DataSection = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  min-height: 0;
`;

const LoadingWrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Record = ({
  dateLoading,
  recordLoading,
  recordDates,
  record,
  onOpenModal,
  target,
  onSelectDate,
  selectedDate,
  onChangeDate,
  findRecordFreeweightType,
}) => {
  if (!target)
    return (
      <Container>
        <EmptyBlock>회원을 선택해 주세요</EmptyBlock>
      </Container>
    );
  
  if (!recordDates)
    return (
      <Container>
        <EmptyBlock>불러올 데이터가 없습니다.</EmptyBlock>
      </Container>
    );

  return (
    <Container>
      <ContentsBlock>
        <DateSection>
          <RecordDate
            dates={recordDates}
            loading={dateLoading}
            onSelectDate={onSelectDate}
            selectedDate={selectedDate}
          />
        </DateSection>
        <DataSection>
          {recordLoading ? (
            <LoadingWrapper>
              <Loading />
            </LoadingWrapper>
          ) : record ? (
            <RecordData
              onOpenModal={onOpenModal}
              record={record}
              loading={recordLoading}
              selectedDate={selectedDate}
              onChangeDate={onChangeDate}
              findRecordFreeweightType={findRecordFreeweightType}
            />
          ) : (
            <LoadingWrapper>
              <div style={{ color: '#666', fontSize: '15px' }}>불러올 데이터가 없습니다.</div>
            </LoadingWrapper>
          )}
        </DataSection>
      </ContentsBlock>
    </Container>
  );
};

export default Record;
